import {
  TImagesBucketDB,
  TImageDBLockedBy,
  TImageStore,
  TBulkEvent,
  TImagesBucketMetadataDB,
  TServerImagesBucketDB,
  TInitStoreLockedBy,
  TRemoteDeploymentCheck,
  TBgImageSyncChainActions,
  TImagesBucket,
} from '@monorepo/types';
import { Action } from '@ngrx/store';
import { TBucketId, TBucketInfo } from 'libs/services/src/lib/capacitor/bucket-storage.types';

export enum InputAppImageDBActionTypes {
  InitImageStoreAndReleaseAllLocks = 'InitImageStoreAndReleaseAllLocks',
  UpdateImageDBLockDetails = 'UpdateImageDBLockDetails',
  ReleaseImageDBLock = 'ReleaseImageDBLock',
  ReleaseImageMetadataDBLock = 'ReleaseImageMetadataDBLock',
  ReleaseImageDBLockAndImageMetadataDBLock = 'ReleaseImageDBLockAndImageMetadataDBLock',
  UpdateSyncedImagesBucketDBLockDetails = 'UpdateSyncedImagesBucketDBLockDetails',
  UpdateServerImagesBucketDBLockDetails = 'UpdateServerImagesBucketDBLockDetails',
  AddImagesBucketAndThenReleaseLock = 'AddImagesBucketAndCommitAndThenReleaseLockAndThenSyncImages',
  AddImagesBucketFromBucketIdsOnBulkAndThenReleaseLock = 'AddImagesBucketFromBucketIdsOnBulkAndThenReleaseLockAndThenSyncImages',
  CommitImagesBucketAndThenAddImagesBucketAndThenReleaseLock = 'CommitImagesBucketAndThenAddImagesBucketAndThenReleaseLock',
  AcquireLockAndAddImagesBucketAndCommitAndThenReleaseLock = 'AcquireLockAndAddImagesBucketAndCommitAndThenReleaseLockAndThenSyncImages',
  AcquireLockAndAddImagesBucketOnBulkAndThenReleaseLock = 'AcquireLockAndAddImagesBucketOnBulkAndThenReleaseLockAndThenSyncImages',
  SyncImagesBucketAndThenReleaseLock = 'SyncImagesBucketAndThenReleaseLock',
  AcquireLockAndBackfillMissingServerImagesBucketList = 'AcquireLockAndBackfillMissingServerImagesBucketList',
  BackfillMissingServerImagesBucketListAndReleaseLock = 'BackfillMissingServerImagesBucketListAndReleaseLock',
  UpdateServerImagesBucketDBAndReleaseLock = 'UpdateServerImagesBucketDB',
  AcquireLockAndThenSyncImagesBucketAndThenReleaseLock = 'AcquireLockAndThenSyncImagesBucketAndThenReleaseLock',
  UpdateImagesBucketDBAndReleaseLock = 'UpdateImagesBucketDBAndReleaseLockAndThenAddBulkEvent',
  UpdateImagesBucketMetadataDBAndReleaseLock = 'UpdateImagesBucketMetadataDBAndReleaseLock',
  UpdateImagesStoreAllDBsAndReleaseAllLocks = 'UpdateImagesStoreAllDBsAndReleaseAllLocks',
  ImageDBNoAction = 'ImageDBNoAction',
  AcquireAllLocksAndInitImageStore = 'AcquireAllLocksAndInitImageStore',
}

export class AcquireAllLocksAndInitImageStore implements Action {
  readonly type = InputAppImageDBActionTypes.AcquireAllLocksAndInitImageStore;
  constructor(public initBy: TInitStoreLockedBy) {}
}

export class InitImageStoreAndReleaseAllLocks implements Action {
  readonly type = InputAppImageDBActionTypes.InitImageStoreAndReleaseAllLocks;
  constructor(public initBy: TInitStoreLockedBy) {}
}

export class UpdateImageDBLockDetails implements Action {
  readonly type = InputAppImageDBActionTypes.UpdateImageDBLockDetails;
  constructor(public lockDetails: TImageStore['imagesBucketDBLockDetails']) {}
}

export class ReleaseImageDBLock implements Action {
  readonly type = InputAppImageDBActionTypes.ReleaseImageDBLock;
  constructor() {}
}

export class ReleaseImageMetadataDBLock implements Action {
  readonly type = InputAppImageDBActionTypes.ReleaseImageMetadataDBLock;
  constructor() {}
}

export class ReleaseImageDBLockAndImageMetadataDBLock implements Action {
  readonly type = InputAppImageDBActionTypes.ReleaseImageDBLockAndImageMetadataDBLock;
  constructor() {}
}

export class UpdateSyncedImagesBucketDBLockDetails implements Action {
  readonly type = InputAppImageDBActionTypes.UpdateSyncedImagesBucketDBLockDetails;
  constructor(public lockDetails: TImageStore['imagesBucketMetadataDBLockedDetails']) {}
}

export class UpdateServerImagesBucketDBLockDetails implements Action {
  readonly type = InputAppImageDBActionTypes.UpdateServerImagesBucketDBLockDetails;
  constructor(public lockDetails: TImageStore['serverImagesBucketMetadataDBLockedDetails']) {}
}

export class AcquireLockAndAddImagesBucketAndCommitAndThenReleaseLock implements Action {
  readonly type = InputAppImageDBActionTypes.AcquireLockAndAddImagesBucketAndCommitAndThenReleaseLock;
  constructor(public bucketInfo: TBucketInfo, public commitId: TBucketId, public eventTime: number) {}
}

export class AcquireLockAndAddImagesBucketOnBulkAndThenReleaseLock implements Action {
  readonly type = InputAppImageDBActionTypes.AcquireLockAndAddImagesBucketOnBulkAndThenReleaseLock
  constructor(public bucketIds: TBucketId[], public eventTime: number) {}
}

export class CommitImagesBucketAndThenAddImagesBucketAndThenReleaseLock implements Action {
  readonly type = InputAppImageDBActionTypes.CommitImagesBucketAndThenAddImagesBucketAndThenReleaseLock;
  constructor(public bucketInfo: TBucketInfo, public commitId: TBucketId, public eventTime: number) {}
}

export class AddImagesBucketAndThenReleaseLock implements Action {
  readonly type = InputAppImageDBActionTypes.AddImagesBucketAndThenReleaseLock;
  constructor(public bucketInfo: TBucketInfo, public eventTime: number) {}
}

export class AddImagesBucketFromBucketIdsOnBulkAndThenReleaseLock implements Action {
  readonly type = InputAppImageDBActionTypes.AddImagesBucketFromBucketIdsOnBulkAndThenReleaseLock;
  constructor(public bucketIds: TBucketId[], public eventTime: number) {}
}

export class AcquireLockAndThenSyncImagesBucketAndThenReleaseLock implements Action {
  readonly type = InputAppImageDBActionTypes.AcquireLockAndThenSyncImagesBucketAndThenReleaseLock;
  constructor(public chainActions: TBgImageSyncChainActions) {}
}

export class UpdateImagesBucketDBAndReleaseLock implements Action {
  readonly type = InputAppImageDBActionTypes.UpdateImagesBucketDBAndReleaseLock;
  constructor(public imagesBucketDB: TImagesBucketDB) {}
}

export class UpdateImagesBucketMetadataDBAndReleaseLock implements Action {
  readonly type = InputAppImageDBActionTypes.UpdateImagesBucketMetadataDBAndReleaseLock;
  constructor(public imagesBucketMetadataDB: TImagesBucketMetadataDB, public chainActions: TBgImageSyncChainActions) {}
}

export class UpdateImagesStoreAllDBsAndReleaseAllLocks implements Action {
  readonly type = InputAppImageDBActionTypes.UpdateImagesStoreAllDBsAndReleaseAllLocks;
  constructor(
    public severImagesBucketDB: TServerImagesBucketDB,
    public imagesBucketDB: TImagesBucketDB,
    public imagesBucketMetadataDB: TImagesBucketMetadataDB,
    public initBy: TInitStoreLockedBy,
  ) {}
}

export class SyncImagesBucketAndThenReleaseLock implements Action {
  readonly type = InputAppImageDBActionTypes.SyncImagesBucketAndThenReleaseLock;
  constructor(public chainActions: TBgImageSyncChainActions) {}
}

export class ImageDBNoAction implements Action {
  readonly type = InputAppImageDBActionTypes.ImageDBNoAction;
  constructor() {}
}

export class AcquireLockAndBackfillMissingServerImagesBucketList implements Action {
  readonly type = InputAppImageDBActionTypes.AcquireLockAndBackfillMissingServerImagesBucketList;
  constructor() {}
}

export class BackfillMissingServerImagesBucketListAndReleaseLock implements Action {
  readonly type = InputAppImageDBActionTypes.BackfillMissingServerImagesBucketListAndReleaseLock;
  constructor() {}
}

export class UpdateServerImagesBucketDBAndReleaseLock implements Action {
  readonly type = InputAppImageDBActionTypes.UpdateServerImagesBucketDBAndReleaseLock;
  constructor(public serverImagesBucketDB: TServerImagesBucketDB) {}
}

export type TInputAppImageDBActions =
  | InitImageStoreAndReleaseAllLocks
  | UpdateImageDBLockDetails
  | ReleaseImageDBLockAndImageMetadataDBLock
  | ReleaseImageDBLock
  | ReleaseImageMetadataDBLock
  | UpdateSyncedImagesBucketDBLockDetails
  | UpdateServerImagesBucketDBLockDetails
  | UpdateServerImagesBucketDBAndReleaseLock
  | UpdateImagesBucketMetadataDBAndReleaseLock
  | UpdateImagesStoreAllDBsAndReleaseAllLocks
  | UpdateImagesBucketDBAndReleaseLock;
